import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const CREATE_QUERY = print(gql`
  mutation CreateBlogCategory($data: CreateBlogCategoryInput!) {
    createBlogCategory(data: $data) {
      id
    }
  }
`);

export interface CreateGql {
  createBlogCategory: {
    id: number;
  };
}
